import { faCaretRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "@mui/material";
import React, { useState } from "react";
import { scroller } from "react-scroll";
import { useSpring, config, animated } from "react-spring";
import PodcastHeroImage from "../../../components/layouts/hero-image/PodcastHeroImage";
import Section from "../../../components/layouts/section/Section";
import styles from "./PodcastHeroImageSection.module.scss";

type Props = {};

const ID_PREFIX = "podcast-hero-image-section";

function PodcastHeroImageSection({}: Props) {
  const [isVisible, setIsVisible] = useState(false);

  const anim2 = useSpring({
    from: {
      opacity: 0,
      x: -200,
    },
    to: {
      opacity: 1,
      x: 0,
    },
    config: config.default,
    delay: 300,
  });

  const anim3 = useSpring({
    from: {
      opacity: 0,
      x: -200,
    },
    to: {
      opacity: 1,
      x: 0,
    },
    config: config.default,
    delay: 600,
  });

  const anim4 = useSpring({
    from: {
      x: 100,
      opacity: 0,
    },
    to: {
      x: 0,
      opacity: 1,
    },
    config: config.default,
    delay: 1200,
  });

  const handleChange = (visible: boolean) => {
    if (visible) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  const handleButtonClick = () => {
    scroller.scrollTo("waitlist", {
      duration: 1000,
      delay: 0,
      smooth: true,
      offset: 100,
    });
  };

  return (
    <Section
      id={`${ID_PREFIX}-text-overlay`}
      pogrId={`${ID_PREFIX}-text-overlay`}
    >
      <PodcastHeroImage />
      <div
        id={`${ID_PREFIX}-text-overlay`}
        data-pogr-id={`${ID_PREFIX}-text-overlay`}
        className={styles.textOverlay}
      >
        <div
          id={`${ID_PREFIX}-textbox`}
          data-pogr-id={`${ID_PREFIX}-textbox`}
          className={styles.textBox}
        >
          <animated.h1
            id={`${ID_PREFIX}-animated-title`}
            data-pogr-id={`${ID_PREFIX}-animated-title`}
            style={anim2}
          >
            LVLUP <br /> WITH POGR
          </animated.h1>
          <animated.h4
            id={`${ID_PREFIX}-animated-description`}
            data-pogr-id={`${ID_PREFIX}-animated-description`}
            style={anim3}
          >
            We go through news, players, games and the direction gaming is
            taking. Perfect listen when you wanna get in the right mood.
          </animated.h4>
          {/* <animated.div
            id={`${ID_PREFIX}-episodes-animated-button`}
            data-pogr-id={`${ID_PREFIX}-episodes-animated-button`}
            style={anim4}
          >
            <div className={styles.row}>
              <Button
                variant="contained"
                color="primary"
                size="large"
                endIcon={
                  <FontAwesomeIcon icon={faCaretRight} height={8} width={6} />
                }
                onClick={handleButtonClick}
              >
                LVLup episodes
              </Button>
            </div>
          </animated.div> */}
        </div>
      </div>
    </Section>
  );
}

export default PodcastHeroImageSection;
